import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing }) => ({
  root: {
    padding: 0,
    '& .MuiPaper-root': {
      width: '100%',
    },
  },
  container: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  form: {
    width: '100%',
    flex: 1,
  },
  dialogContent: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing(20),
    padding: spacing(40),
    minHeight: spacing(50),
    marginTop: spacing(20),
  },
  ratingContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    justifyContent: 'center',
    alignItems: 'center',
    justifyItems: 'center',
    gap: spacing(26),
  },
  infoText: {
    marginTop: spacing(30),
    display: 'flex',
    alignItems: 'flex-start',
    gap: spacing(6),

    '& svg': {
      marginTop: spacing(6),
      flexShrink: 0,
    },
  },
}))
